














import { Vue, Component, Prop } from 'vue-property-decorator';

/**
 *
 */
@Component({
    components: {},
})
export default class Profittable extends Vue {
    /** */
    @Prop({ default: [] })
    columns!: Array<Record<string, string>>;

    /** */
    @Prop({ default: [] })
    dataSource!: Array<Record<string, string>>;
    /**
     * 获得theme
     */
    get theme(): boolean {
        return this.$store.getters.getTheme;
    }
}
